import { createBlockStyleButton } from '@draft-js-plugins/buttons';
import mdTitleIcon from '@sb1/ffe-icons/icons/open/300/md/title.svg';
import smTitleIcon from '@sb1/ffe-icons/icons/open/300/sm/title.svg';
import { Icon } from '@sb1/ffe-icons-react';
import { Tooltip } from '../tooltip/Tooltip';

const TitleButton = createBlockStyleButton({
    blockType: 'header-two',
    children: (
        <>
            <Icon fileUrl={mdTitleIcon} />
        </>
    ),
});
const SubTitleButton = createBlockStyleButton({
    blockType: 'header-three',
    children: (
        <>
            <Icon fileUrl={smTitleIcon} size="sm" />
        </>
    ),
});

export function TitleButtonItem(props) {
    return (
        <Tooltip text="Stor tittel">
            <TitleButton {...props} />
        </Tooltip>
    );
}

export function SubTitleButtonItem(props) {
    return (
        <Tooltip text="Liten tittel">
            <SubTitleButton {...props} />
        </Tooltip>
    );
}
